import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'What Is GEO', id: 'what-is-geo' },
  { label: 'SEO vs GEO', id: 'seo-vs-geo' },
  { label: 'How It Works', id: 'how-it-works' },
  { label: "What's Included", id: 'whats-included' },
  { label: 'Process', id: 'geo-process' },
  { label: 'Pricing', id: 'geo-pricing' },
];

export default function GeoNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (id: string) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${scrolled ? 'bg-ds-bg/95 border-b border-ds-border' : 'bg-transparent'}`}
      style={{ backdropFilter: scrolled ? 'blur(12px)' : 'none' }}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16">
        {/* Logo — links back to home */}
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://storage.readdy-site.link/project_files/cb16f62b-b978-4a18-b0d4-78b46c2aa554/9ae0cf67-cf30-4444-9d14-012a7830e862_Darkside-Digital-logo-design.png?v=7acdaa383d113350b9c301867b0d13f1"
            alt="Darkside Digital"
            className="h-9 w-auto object-contain"
            width="180"
            height="36"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
        </Link>

        {/* Back to home pill + desktop links */}
        <div className="hidden lg:flex items-center gap-6">
          <Link
            to="/"
            className="flex items-center gap-1.5 font-body text-xs text-white/40 hover:text-white transition-colors duration-200 tracking-widest uppercase whitespace-nowrap"
          >
            <i className="ri-arrow-left-line text-xs" />
            Home
          </Link>
          <div className="w-px h-4 bg-ds-border" />
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNav(link.id)}
              className="text-white/60 hover:text-white font-body text-xs tracking-widest uppercase transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
        </div>

        {/* CTA */}
        <button
          onClick={() => handleNav('geo-pricing')}
          className="hidden lg:flex btn-red text-xs whitespace-nowrap"
        >
          Free AI Visibility Audit
        </button>

        {/* Hamburger */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="lg:hidden flex flex-col gap-1.5 cursor-pointer p-1"
          aria-label="Toggle menu"
        >
          <span className={`w-6 h-0.5 bg-white transition-all duration-300 ${mobileOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`w-6 h-0.5 bg-white transition-all duration-300 ${mobileOpen ? 'opacity-0' : ''}`} />
          <span className={`w-6 h-0.5 bg-white transition-all duration-300 ${mobileOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ${mobileOpen ? 'max-h-80' : 'max-h-0'}`}
        style={{ background: '#0A0A0A', borderBottom: mobileOpen ? '1px solid #222' : 'none' }}
      >
        <div className="flex flex-col px-6 py-4 gap-4">
          <Link to="/" className="text-white/40 hover:text-white font-body text-sm tracking-widest uppercase flex items-center gap-1.5 cursor-pointer transition-colors duration-200">
            <i className="ri-arrow-left-line text-xs" />
            Back to Home
          </Link>
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNav(link.id)}
              className="text-white/70 hover:text-ds-red font-body text-sm tracking-widest uppercase text-left transition-colors duration-200 cursor-pointer"
            >
              {link.label}
            </button>
          ))}
          <button onClick={() => handleNav('geo-pricing')} className="btn-red w-fit mt-2">
            Free AI Visibility Audit
          </button>
        </div>
      </div>
    </nav>
  );
}
